module.exports = __webpack_public_path__ + "static/media/Icon awesome-youtube.cea1b34a.svg";